var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 61,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9F3FF",
    fillRule: "evenodd",
    d: "M97.725 9.334A4.27 4.27 0 0 1 102 13.598a4.27 4.27 0 0 1-4.275 4.264H73.293a4.27 4.27 0 0 1 4.276 4.265 4.27 4.27 0 0 1-4.276 4.264h13.438a4.27 4.27 0 0 1 4.275 4.264 4.27 4.27 0 0 1-4.275 4.264h-6.215c-2.977 0-5.39 1.91-5.39 4.264 0 1.57 1.221 2.992 3.664 4.265a4.27 4.27 0 0 1 4.276 4.264 4.27 4.27 0 0 1-4.276 4.264H28.096a4.27 4.27 0 0 1-4.276-4.264 4.27 4.27 0 0 1 4.276-4.264H4.276A4.27 4.27 0 0 1 0 39.183a4.27 4.27 0 0 1 4.275-4.264h24.432a4.27 4.27 0 0 0 4.275-4.264 4.27 4.27 0 0 0-4.275-4.264h-15.27a4.27 4.27 0 0 1-4.275-4.264 4.27 4.27 0 0 1 4.275-4.265h24.431a4.27 4.27 0 0 1-4.275-4.264 4.27 4.27 0 0 1 4.275-4.264h59.857Zm0 17.057A4.27 4.27 0 0 1 102 30.655a4.27 4.27 0 0 1-4.275 4.264 4.27 4.27 0 0 1-4.276-4.264 4.27 4.27 0 0 1 4.276-4.264Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.114 17.872c0-1.01.82-1.828 1.83-1.828h16.255c.685 0 1.313.383 1.626.993l1.418 2.758c.313.61.94.993 1.626.993h24.18c1.01 0 1.828.819 1.828 1.829v35.485c0 1.01-.819 1.828-1.828 1.828H21.943a1.829 1.829 0 0 1-1.829-1.828v-40.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#94BEE2",
    fillRule: "evenodd",
    d: "M21.943 16.964a.916.916 0 0 0-.914.917v40.357c0 .506.41.917.914.917h45.105c.505 0 .915-.41.915-.917V22.64a.916.916 0 0 0-.915-.918H42.87a2.742 2.742 0 0 1-2.44-1.493l-1.417-2.768a.914.914 0 0 0-.813-.498H21.943Zm-2.743.917a2.747 2.747 0 0 1 2.743-2.752H38.2c1.028 0 1.97.577 2.44 1.494l1.417 2.768c.157.306.47.498.813.498h24.18a2.747 2.747 0 0 1 2.742 2.752v35.597a2.747 2.747 0 0 1-2.743 2.751H21.943a2.747 2.747 0 0 1-2.743-2.751V17.88Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9F3FF",
    d: "M23.162 19.7a1.22 1.22 0 0 1 1.22-1.218h12.005c.434 0 .835.23 1.054.606l2.134 3.67c.216.372.613.602 1.044.606l24.001.194c.67.006 1.21.55 1.21 1.22v32.104a1.22 1.22 0 0 1-1.22 1.22H24.381a1.22 1.22 0 0 1-1.219-1.22V19.701Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.181 29.44a2.438 2.438 0 0 1 2.357-1.815h43.705c1.6 0 2.767 1.515 2.357 3.062l-7.256 27.428a2.438 2.438 0 0 1-2.357 1.815H23.282a2.438 2.438 0 0 1-2.358-3.062l7.257-27.429Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#94BEE2",
    fillRule: "evenodd",
    d: "M27.297 29.217a3.355 3.355 0 0 1 3.241-2.506h43.705c2.2 0 3.804 2.092 3.241 4.228l-7.257 27.553a3.355 3.355 0 0 1-3.24 2.506H23.282c-2.2 0-3.804-2.092-3.241-4.228l7.256-27.553Zm3.241-.67c-.691 0-1.296.468-1.473 1.14l-7.257 27.552a1.53 1.53 0 0 0 1.474 1.922h43.705c.691 0 1.296-.467 1.473-1.139l7.257-27.552a1.53 1.53 0 0 0-1.474-1.923H30.538Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9F3FF",
    d: "M31.086 30.958a1.219 1.219 0 0 1 1.175-.895h8.938c.631 0 1.156.485 1.231 1.113 1.605 13.451 10.426 21.789 23.765 22.874.76.062 1.307.775 1.138 1.518l-.221.975a1.22 1.22 0 0 1-1.189.949h-40.55a1.22 1.22 0 0 1-1.176-1.543l6.889-24.99Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.696,
    cy: 13.301,
    r: 2.133,
    fill: "#94BEE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#94BEE2",
    fillRule: "evenodd",
    d: "M44.496 4.656a1.22 1.22 0 1 0 0-2.439 1.22 1.22 0 0 0 0 2.439Zm0 1.219a2.438 2.438 0 1 0 0-4.877 2.438 2.438 0 0 0 0 4.877ZM54.366 8.908a.61.61 0 0 1 0 .862l-2.154 2.154 2.182 2.183a.61.61 0 0 1-.862.862l-2.182-2.183-2.156 2.156a.61.61 0 0 1-.862-.862l2.155-2.156-2.127-2.127a.61.61 0 0 1 .862-.862l2.127 2.127 2.155-2.154a.61.61 0 0 1 .862 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/no-messages.cf74b6d2e970abd8bab4e4610f3d2767.svg";
export { ForwardRef as ReactComponent };